// flow weak

  import React, { Component }     from 'react';
  import PropTypes                    from 'prop-types';
  import AnimatedView                 from '../../../../components';
  import styles                       from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                                   from '../../../../services/fetchTools';
  import { Spinner }                  from 'react-activity';
  
  
  class AddLocation extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        data: [],
        loading: false,
        details: {
          name:'',
          description:'',
          latitude:'',
          longitude:'',
          city:2,
          is_active:false
        }
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
    }
  
    componentDidMount() {
        this.getDetails();
    }  

    getDetails(){
      const url = `${getLocationOrigin()}/location/get_details_for_location_addition`;
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
              if(data.success){
                this.setState({success:data.success,message:data.message,loading:false,data:data.result})
              }
              else{
                alert(data.message)
                this.setState({success:data.success,message:data.message,loading:false})
              }
             // alert("fix");
         }).catch(error => error);
      }

    verifyLocation = (tag,value) => {
      let splits = value.split('.')
      let msg = ''
      if(!value){
        msg  = `Please Enter ${tag}`
        return msg
      }
      else if(splits && splits.length != 2){
        msg  = `Please Enter ${tag} Properly`
        return msg
      }
      else if(splits && splits.length == 2) {
        if(splits[1].length != 8 ){
          msg = `Please Enter ${tag} Properly`
          return msg
        }
      }
    }

    postUpdateBooking(details,props) {
      console.log(details)
      let res_lat =  this.verifyLocation('Latitude',details.latitude)
      let res_long = this.verifyLocation('Longitude',details.longitude)
      if(!details.name){
        alert('Please Enter Location Name')
      }
      else if(res_lat){
        alert(res_lat)
      }
      else if(res_long){
        alert(res_long)
      }
      else{
        const url = `${getLocationOrigin()}/location/add_location/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'details': details
                                        });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(response=>{  
            console.log('response',response)
            alert(response.message)
            if(response.success){
              window.location.reload()
            }
            
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
        }
      }

    handleChange(event) {
        const name = event.target.name;
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        var new_value =  Object.assign({}, this.state.details);
        new_value[name] = value
        this.setState({details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        this.postUpdateBooking(this.state.details ,this.props)
      }
  
    render() {
      // console.log('here is the data',this.state.details)
      return(
        <div style={styles.container}> 

          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}> Add Location</h3>
            </div>
              <form  className="validated-form form-horizontal">

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Name
                  </div>
                  <input style={styles.input} name="name" value={this.state.details.name}
                  onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Description
                  </div>
                  <textarea style={styles.textbox} name="description" placeholder="If nothing, enter google map url to the location.." rows="5" onChange={this.handleChange}/>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Latitude
                  </div>
                  <input style={styles.input} type="number" name="latitude" placeholder='example - 10.54611090 ...' onChange={this.handleChange}/>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Longitude
                  </div>
                  <input style={styles.input} type="number" name="longitude" placeholder='example - 76.17353650 ...' onChange={this.handleChange}/>
                </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  City
                </div>
               <select name="city" className="col-md-6" style={styles.item_body} 
                 onChange={this.handleChange} value={this.state.details.city}>
                  {
                     this.state.data && this.state.data.length > 0 && this.state.data.map((city,index)=>(
                       <option key={city.id} value={city.id}>{city.name}</option>
                      ))
                   }
               </select>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">Is Active ? </div>
                <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_active' onChange={this.handleChange}/></div>
              </div>
             
              <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                <div style={styles.button_submit} className="col-md-12">
                  <input className="btn btn-lg" type="submit" value="Add Location" onClick={this.handleSubmit} style={{backgroundColor:'#302C35',
                    color:'#ffffff'}}/>
                </div>
              </div>
                
            </form>
          { this.state.loading &&
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
          }
          </div>
        </div>
      );
    }
  }
  
  export default AddLocation;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addLocation/AddLocation.js